import { configureStore } from "@reduxjs/toolkit";

// Create store with empty reducers initially
export const store = configureStore({
  reducer: {
    auth: (state = {}, action) => state,
    meta: (state = {}, action) => state,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// We'll update the reducers after they're created
